import { Badge, Tooltip } from '@fluentui/react-components';

export interface VersionStatusBadgeProps {
  isDraft: boolean;
  version?: number;
}

export function VersionStatusBadge({
  isDraft,
  version,
}: VersionStatusBadgeProps) {
  const versionLabel = version === undefined ? 'v…' : `v${String(version)}`;
  const explanation = isDraft
    ? version === undefined
      ? 'The working copy has changes that are not snapshotted.'
      : `Draft working copy based on snapshot ${versionLabel}.`
    : version === undefined
      ? 'The working copy matches the latest snapshot.'
      : `Active working copy at snapshot ${versionLabel}.`;

  return (
    <Tooltip content={explanation} relationship="description">
      <Badge
        size="small"
        appearance="tint"
        color={isDraft ? 'warning' : 'success'}
        aria-label={
          isDraft ? `${versionLabel}, draft changes` : `${versionLabel}, active`
        }
      >
        {versionLabel}
      </Badge>
    </Tooltip>
  );
}
